module.exports = __webpack_public_path__ + "static/media/profile-picture-338w.c8f6a41e.jpg";